import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const SchoolDriveLazy = React.lazy(
	() => import(/* webpackChunkName : 'Home' */ './components/SchoolDrive')
);

export default (store) => {
	return [
		{
			path: 'home/school-drive',
			element: (
				<AsyncLoading
					component={
						<SchoolDriveLazy
							permission="CanViewSchoolDrive"
							featureFlag="Module:SchoolDrive"
						/>
					}
				/>
			),
		},
		{
			path: 'home/school-drive/:resourceId',
			element: (
				<AsyncLoading
					component={
						<SchoolDriveLazy
							permission="CanViewSchoolDrive"
							featureFlag="Module:SchoolDrive"
						/>
					}
				/>
			),
		},
	];
};
